import { Link } from 'react-router-dom';
import { Button } from '../components/ui.js';

export default function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center gap-2.5 px-[22px] py-20 text-center">
      <p className="text-[64px] leading-none font-extrabold text-line-dashed">404</p>
      <h1 className="text-[19px] md:text-[21px] font-extrabold tracking-[-0.03em]">That screen does not exist</h1>
      <p className="text-[13.5px] md:text-[15px] text-muted">The link may be old, or the meal may have closed.</p>
      <div className="mt-4 w-full max-w-[240px]">
        <Link to="/">
          <Button variant="outline">Back to today</Button>
        </Link>
      </div>
    </div>
  );
}
